
// 添霖
// 技能管理、申請入駐、最近來訪、礼物、排行榜、静态介绍页、活动页

const routers = [
  // 技能管理
  {
    path: '/skill-list',
    name: 'skillList',
    component: () => import(/* webpackChunkName: "skill-manage" */ './pages/skill-manage/skill-list.vue'),
    meta: {
      waitUserInfo: true,
    },
  },
  // 设置技能信息
  {
    path: '/edit-skill-info',
    name: 'editSkillInfo',
    component: () =>
      import(
        /* webpackChunkName: "skill-manage" */ './pages/skill-manage/edit-skill-info.vue'
      ),
  },
  {
    path: '/skill-property',
    name: 'skillProperty',
    component: () =>
      import(
        /* webpackChunkName: "skill-manage" */ './pages/skill-manage/set-property.vue'
      ),
  },
  {
    path: '/set-send-rule',
    name: 'setSendRule',
    component: () =>
      import(
        /* webpackChunkName: "skill-manage" */ './pages/skill-manage/set-send-rule.vue'
      ),
  },
  {
    path: '/first-order-discount',
    name: 'firstOrderDiscount',
    component: () =>
      import(
        /* webpackChunkName: "skill-manage" */ './pages/skill-manage/first-order-discount.vue'
      ),
  },
  {
    path: '/skill-detail',
    name: 'skillDetail',
    component: () =>
      import(
        /* webpackChunkName: "skill-manage" */ './pages/skill-manage/skill-detail.vue'
      ),
  },
  {
    path: '/set-skill-price',
    name: 'setSkillPrice',
    component: () =>
      import(
        /* webpackChunkName: "settle-manage" */ './pages/skill-manage/set-skill-price.vue'
      ),
  },
  {
    path: '/set-more-price',
    name: 'setMorePrice',
    component: () =>
      import(
        /* webpackChunkName: "settle-manage" */ './pages/skill-manage/set-more-price.vue'
      ),
  },
  // 申請入駐
  {
    path: '/before-settle-in',
    name: 'beforeSettleIn',
    component: () =>
      import(
        /* webpackChunkName: "settle-in" */ './pages/settle-in/before.vue'
      ),
  },
  {
    path: '/settle-in',
    name: 'settleIn',
    component: () =>
      import(/* webpackChunkName: "settle-in" */ './pages/settle-in/index.vue'),
  },
  {
    path: '/settle-in-success',
    name: 'settleInSuccess',
    component: () =>
      import(/* webpackChunkName: "settle-in" */ './pages/settle-in/settle-in-success.vue'),
  },
  // 白名单用户申请成为陪玩师
  {
    path: '/apply-player-user-settle-in',
    name: 'whiteListUserSettleIn',
    component: () =>
      import(/* webpackChunkName: "settle-in" */ './pages/settle-in/apply-player-user-settle-in.vue'),
  },
  {
    path: '/settle-message',
    name: 'settleMessage',
    component: () =>
      import(/* webpackChunkName: "settle-in" */ './pages/settle-in/fill-message.vue'),
  },
  {
    path: '/settle-question',
    name: 'settleQuestion',
    component: () =>
      import(/* webpackChunkName: "settle-in" */ './pages/settle-in/question/question.vue'),
  },
  {
    path: '/settle-checking',
    name: 'settleChecking',
    component: () =>
      import(/* webpackChunkName: "settle-in" */ './pages/settle-in/checking-skill.vue'),
  },
  // 最近下單
  {
    path: '/recent-order',
    name: 'recentOrder',
    component: () =>
      import(
        /* webpackChunkName: "user-visitor" */ './pages/user-center/recent-order.vue'
      ),
  },
  // 最近來訪
  {
    path: '/user-visitor',
    name: 'userVisitor',
    component: () =>
      import(
        /* webpackChunkName: "user-visitor" */ './pages/visitor/index.vue'
      ),
  },
  // 我看过
  {
    path: '/user-watch',
    name: 'userWatch',
    component: () =>
      import(
        /* webpackChunkName: "user-watch" */ './pages/watch/index.vue'
      ),
  },
  // 礼物
  {
    path: '/gifts-wall',
    name: 'giftsWall',
    component: () =>
      import(/* webpackChunkName: "gifts-wall" */ './views/gifts-wall.vue'),
  },
  {
    path: '/person-receive-gift',
    name: 'personReceiveGift',
    component: () =>
      import(
        /* webpackChunkName: "gifts-wall" */ './views/person-receive-gift.vue'
      ),
    meta: {
      waitUserInfo: true,
    },
  },
  // 排行榜 - 个人
  {
    path: '/player-ranking',
    name: 'playerRanking',
    component: () =>
      import(
        /* webpackChunkName: "ranking-player" */ './pages/player-ranking'
      ),
    meta: {
      keepAlive: true,
    },
  },
  // 排行榜 - 总榜
  {
    path: '/home-ranking',
    name: 'homeRanking',
    component: () =>
      import(/* webpackChunkName: "ranking-home" */ './views/home-ranking.vue'),
    meta: {
      keepAlive: true,
    },
  },
  // 怎样成为回单王
  {
    path: '/score-detail',
    name: 'scoreDetail',
    component: () => import(/* webpackChunkName: "score" */ './pages/score'),
  },
  // 如何獲得訂單
  {
    path: '/order-score',
    name: 'orderScore',
    component: () =>
      import(/* webpackChunkName: "score" */ './pages/score/order-score'),
  },
  // b端质量分详情
  {
    path: '/score2-explain',
    name: 'score2Explain',
    component: () => import(/* webpackChunkName: "score" */ './pages/score/score2-explain-page'),
  },
  // 官方Line
  {
    path: '/join-line',
    name: 'joinLine',
    component: () => import(/* webpackChunkName: "user-center" */ './pages/user-center/join-line'),
  },
  // 语音房列表
  {
    path: '/voice-room-list',
    name: 'voiceRoomList',
    component: () => import(/* webpackChunkName: "voice-room" */ './pages/voice-room'),
    meta: {
      waitUserInfo: true,
    },
  },
  // 语音房权限列表
  {
    path: '/room-power-list',
    name: 'roomPowerList',
    component: () => import(/* webpackChunkName: "voice-room" */ './pages/voice-room/room-power-list.vue'),
  },
  // 儲值頁面
  {
    path: '/get-coupons',
    name: 'getCoupons',
    component: () => import(/* webpackChunkName: "app-recharge" */ './pages/get-coupons/index.vue'),
  },
  // 自动打招呼
  {
    path: '/chat-self',
    name: 'chatSelf',
    component: () => import(/* webpackChunkName: "chat-self" */ './pages/chat-self/index.vue'),
  },
  // 活动页

  // 愚人節
  {
    path: '/foolsday',
    name: 'foolsday',
    component: () =>
      import(/* webpackChunkName: "activities" */ './activities/foolsday/index'),
  },
  // 中秋活動
  {
    path: '/mid-autumn',
    name: 'midautumn',
    component: () =>
      import(/* webpackChunkName: "activities" */ '@/views/activity/mid-autumn'),
  },
  // { // LOL抽奖页
  //   path: '/luck-draw',
  //   name: 'luckDraw',
  //   component: () =>
  //     import(/* webpackChunkName: "activities" */ './activities/luck-draw/index'),
  // },
  // { // 周年庆
  //   path: '/app-birth',
  //   name: 'appBirth',
  //   component: () =>
  //     import(/* webpackChunkName: "activities" */ './activities/app-birth/index'),
  // },
  // {
  //   path: '/wash-gold',
  //   name: 'washGold',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "activities" */ './activities/wash-gold/index'
  //     ),
  // },
  // {
  //   path: '/slash-page',
  //   name: 'slashPage',
  //   component: () =>
  //     import(/* webpackChunkName: "activities" */ './activities/slash/index'),
  // },
  // {
  //   path: '/double-seven',
  //   name: 'doubleSeven',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "activities" */ './activities/double-seven/index.vue'
  //     ),
  // },
  // { // 中秋节
  //   path: '/mid-autumn',
  //   name: 'midAutumn',
  //   component: () =>
  //     import(/* webpackChunkName: "activities" */ './activities/mid-autumn'),
  // },
  // { // 双11
  //   path: '/double-eleven',
  //   name: 'doubleEleven',
  //   component: () =>
  //     import(/* webpackChunkName: "activities" */ './activities/double-eleven'),
  // },
]

export default routers
